(function () {
	const SELECTOR = '[data-fan-hub]';
	const DEBOUNCE_MS = 200;

	const shuffle = (items, count) => {
		const list = Array.isArray(items) ? items.slice() : [];
		const size = Math.max(0, Math.min(list.length, parseInt(count, 10) || 0));

		for (let i = list.length - 1; i > 0; i -= 1) {
			const j = Math.floor(Math.random() * (i + 1));
			const swap = list[i];
			list[i] = list[j];
			list[j] = swap;
		}

		return list.slice(0, size);
	};

	const debounce = (fn, wait) => {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => fn.apply(null, args), wait);
		};
	};

	const waitFor = (check, done) => {
		if (check()) {
			done();
			return;
		}
		let attempts = 0;
		const wait = setInterval(() => {
			attempts += 1;
			if (check() || attempts > 40) {
				clearInterval(wait);
				done();
			}
		}, 50);
	};

	const readFallback = (root) => {
		const node = root.querySelector('[data-fan-hub-fallback]');
		if (!node) return [];
		try {
			const parsed = JSON.parse(node.textContent || '[]');
			return Array.isArray(parsed)
				? parsed.map((item) => String(item || '').trim()).filter(Boolean)
				: [];
		} catch (error) {
			return [];
		}
	};

	const getCrawl = (root) => root.querySelector('[data-transcript-crawl-managed]');

	const setStatus = (root, text) => {
		const status = root.querySelector('[data-fan-hub-status]');
		if (!status) return;
		if (text) {
			status.textContent = text;
			status.hidden = false;
		} else {
			status.textContent = '';
			status.hidden = true;
		}
	};

	const setEmpty = (root, visible, message) => {
		const empty = root.querySelector('[data-fan-hub-empty]');
		if (!empty) return;
		if (message) empty.textContent = message;
		empty.hidden = !visible;
	};

	const SHARE_ICON =
		'<svg viewBox="0 0 12 12" class="icon icon-share" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M9.12676 7.94366C8.51831 7.94366 7.96056 8.21408 7.57183 8.67042L3.95493 6.72676C4.02254 6.52394 4.05634 6.30423 4.05634 6.08451C4.05634 5.86479 4.02253 5.62817 3.93803 5.42535L7.57183 3.32958C7.96056 3.78592 8.53521 4.05634 9.12676 4.05634C10.2423 4.05634 11.1549 3.14366 11.1549 2.02817C11.1549 0.912676 10.2423 0 9.12676 0C8.01127 0 7.09859 0.912676 7.09859 2.02817C7.09859 2.16338 7.11549 2.28169 7.13239 2.4169L3.38028 4.58028C3.00845 4.24225 2.53521 4.05634 2.02817 4.05634C0.912676 4.05634 0 4.96901 0 6.08451C0 7.2 0.912676 8.11268 2.02817 8.11268C2.53521 8.11268 3.02535 7.92676 3.39718 7.57183L7.13239 9.5831C7.11549 9.71831 7.09859 9.83662 7.09859 9.97183C7.09859 11.0873 8.01127 12 9.12676 12C10.2423 12 11.1549 11.0873 11.1549 9.97183C11.1549 8.85634 10.2423 7.94366 9.12676 7.94366ZM9.12676 1.01408C9.68451 1.01408 10.1408 1.47042 10.1408 2.02817C10.1408 2.58592 9.68451 3.04225 9.12676 3.04225C8.56901 3.04225 8.11268 2.58592 8.11268 2.02817C8.11268 1.47042 8.56901 1.01408 9.12676 1.01408ZM2.02817 7.09859C1.47042 7.09859 1.01408 6.64225 1.01408 6.08451C1.01408 5.52676 1.47042 5.07042 2.02817 5.07042C2.58592 5.07042 3.04225 5.52676 3.04225 6.08451C3.04225 6.64225 2.58592 7.09859 2.02817 7.09859ZM9.12676 10.9859C8.56901 10.9859 8.11268 10.5296 8.11268 9.97183C8.11268 9.41408 8.56901 8.95775 9.12676 8.95775C9.68451 8.95775 10.1408 9.41408 10.1408 9.97183C10.1408 10.5296 9.68451 10.9859 9.12676 10.9859Z" fill="currentColor"/></svg>';

	const shareEnabled = (root) => root.dataset.fanHubShare === 'true';

	const canShareFile = (file) => {
		if (typeof navigator.share !== 'function') return false;
		if (typeof navigator.canShare !== 'function') return true;
		try {
			return navigator.canShare({ files: [file] });
		} catch (error) {
			return false;
		}
	};

	const revokeShareUrl = (root) => {
		if (!root._fanHubShareUrl) return;
		URL.revokeObjectURL(root._fanHubShareUrl);
		root._fanHubShareUrl = '';
	};

	const closeShareDialog = (root) => {
		const dialog = root.querySelector('[data-fan-hub-share-dialog]');
		if (dialog && dialog.open) dialog.close();
	};

	const downloadFile = (file) => {
		const url = URL.createObjectURL(file);
		const link = document.createElement('a');
		link.href = url;
		link.download = file.name || 'in-your-words.png';
		document.body.appendChild(link);
		link.click();
		link.remove();
		setTimeout(() => URL.revokeObjectURL(url), 1000);
	};

	const fillShareDialog = (root, file) => {
		const dialog = root.querySelector('[data-fan-hub-share-dialog]');
		const preview = root.querySelector('[data-fan-hub-share-preview]');
		const nativeBtn = root.querySelector('[data-fan-hub-share-native]');
		if (!dialog || !preview) return;

		revokeShareUrl(root);
		root._fanHubShareFile = file;
		root._fanHubShareUrl = URL.createObjectURL(file);
		preview.src = root._fanHubShareUrl;

		if (nativeBtn) {
			nativeBtn.hidden = !canShareFile(file);
		}

		if (typeof dialog.showModal === 'function') {
			dialog.showModal();
		} else {
			dialog.setAttribute('open', '');
		}
	};

	const openShareCard = (root, text, button) => {
		button.disabled = true;
		button.setAttribute('aria-busy', 'true');

		waitFor(
			() => Boolean(window.FanHubShareCard),
			() => {
				if (!window.FanHubShareCard) {
					button.disabled = false;
					button.removeAttribute('aria-busy');
					return;
				}

				window.FanHubShareCard.render(root, text)
					.then((result) => {
						fillShareDialog(root, result.file);
					})
					.catch((error) => {
						console.error(error);
					})
					.finally(() => {
						button.disabled = false;
						button.removeAttribute('aria-busy');
					});
			}
		);
	};

	const bindShare = (root) => {
		if (!shareEnabled(root) || root.dataset.fanHubShareBound === 'true') return;
		root.dataset.fanHubShareBound = 'true';

		root.addEventListener('click', (event) => {
			const button = event.target.closest('[data-fan-hub-share-btn]');
			if (!button || !root.contains(button)) return;
			const card = button.closest('.fan-hub__card');
			const textNode = card && card.querySelector('.fan-hub__card-text');
			const text = textNode ? textNode.textContent : '';
			if (!text) return;
			event.preventDefault();
			openShareCard(root, text, button);
		});

		const dialog = root.querySelector('[data-fan-hub-share-dialog]');
		if (!dialog) return;

		dialog.addEventListener('click', (event) => {
			if (event.target === dialog) closeShareDialog(root);
		});

		dialog.addEventListener('close', () => {
			revokeShareUrl(root);
			root._fanHubShareFile = null;
			const preview = root.querySelector('[data-fan-hub-share-preview]');
			if (preview) preview.removeAttribute('src');
		});

		const nativeBtn = root.querySelector('[data-fan-hub-share-native]');
		if (nativeBtn) {
			nativeBtn.addEventListener('click', () => {
				const file = root._fanHubShareFile;
				if (!file || !canShareFile(file)) {
					if (file) downloadFile(file);
					return;
				}
				navigator.share({ files: [file], title: root.dataset.fanHubShareLockup || 'In Your Words' }).catch((error) => {
					if (error && error.name === 'AbortError') return;
					downloadFile(file);
				});
			});
		}

		const downloadBtn = root.querySelector('[data-fan-hub-share-download]');
		if (downloadBtn) {
			downloadBtn.addEventListener('click', () => {
				if (root._fanHubShareFile) downloadFile(root._fanHubShareFile);
			});
		}

		const closeBtn = root.querySelector('[data-fan-hub-share-close]');
		if (closeBtn) {
			closeBtn.addEventListener('click', () => closeShareDialog(root));
		}
	};

	const renderList = (root, items) => {
		const list = root.querySelector('[data-fan-hub-list]');
		if (!list) return;
		list.replaceChildren();

		const fragment = document.createDocumentFragment();
		const allowShare = shareEnabled(root);
		items.forEach((text) => {
			const item = document.createElement('li');
			item.className = 'fan-hub__card';

			const body = document.createElement('p');
			body.className = 'fan-hub__card-text';
			body.textContent = text;
			item.appendChild(body);

			if (allowShare) {
				const button = document.createElement('button');
				button.type = 'button';
				button.className = 'fan-hub__share-btn';
				button.dataset.fanHubShareBtn = '';
				button.setAttribute('aria-label', 'Share this message as an image');
				button.innerHTML = `${SHARE_ICON}<span>Share</span>`;
				item.appendChild(button);
			}

			fragment.appendChild(item);
		});
		list.appendChild(fragment);
	};

	const setSearching = (root, isSearch) => {
		root.classList.toggle('is-searching', Boolean(isSearch));
		const crawl = getCrawl(root);
		if (!crawl || !window.TranscriptCrawl) return;

		if (isSearch) {
			window.TranscriptCrawl.stop(crawl);
		} else {
			window.TranscriptCrawl.start(crawl);
		}
	};

	const fillCrawl = (root, items) => {
		const crawl = getCrawl(root);
		if (!crawl || !window.TranscriptCrawl) return;
		window.TranscriptCrawl.fill(crawl, items);
		if (!root.classList.contains('is-searching')) {
			window.TranscriptCrawl.start(crawl);
		}
	};

	const showResults = (root, result) => {
		renderList(root, result.items);

		if (!result.items.length) {
			setStatus(root, '');
			setEmpty(root, true, 'No transcripts mention that word.');
			return;
		}

		setEmpty(root, false);
		const shown = result.items.length;
		setStatus(
			root,
			result.total > shown
				? `Showing ${shown} of ${result.total}`
				: `${result.total} ${result.total === 1 ? 'result' : 'results'}`
		);
	};

	const applyQuery = (root) => {
		const input = root.querySelector('[data-fan-hub-input]');
		const query = input ? input.value : '';
		const cap = parseInt(root.dataset.fanHubCap, 10) || 50;
		const isSearch = Boolean(String(query).trim());

		if (!isSearch) {
			setSearching(root, false);
			setStatus(root, '');
			setEmpty(root, false);
			renderList(root, []);
			return;
		}

		setSearching(root, true);
		if (!window.TranscriptsData) return;
		showResults(root, window.TranscriptsData.search(root._fanHubAll || [], query, cap));
	};

	const bindSearch = (root) => {
		const input = root.querySelector('[data-fan-hub-input]');
		if (!input || root.dataset.fanHubBound === 'true') return;
		root.dataset.fanHubBound = 'true';

		const onInput = debounce(() => applyQuery(root), DEBOUNCE_MS);
		input.addEventListener('input', onInput);
		input.addEventListener('search', () => applyQuery(root));
	};

	const initRoot = (root) => {
		if (!root || root.dataset.fanHubReady === 'true') return;
		root.dataset.fanHubReady = 'true';

		const sampleSize = parseInt(root.dataset.fanHubSample, 10) || 100;
		const csvUrl = (root.dataset.fanHubCsv || '').trim();
		const fallback = readFallback(root);

		const start = (items) => {
			root._fanHubAll = items;
			root._fanHubIdle = shuffle(items, sampleSize);
			waitFor(
				() => Boolean(window.TranscriptCrawl),
				() => {
					fillCrawl(root, root._fanHubIdle);
					bindSearch(root);
					bindShare(root);
					applyQuery(root);
				}
			);
		};

		const loadFromCsv = () => {
			if (!window.TranscriptsData) {
				start(fallback);
				return;
			}

			window.TranscriptsData.fetchTranscripts(csvUrl).then((items) => {
				start(items.length ? items : fallback);
			}).catch(() => {
				start(fallback);
			});
		};

		if (!csvUrl) {
			start(fallback);
			return;
		}

		waitFor(() => Boolean(window.TranscriptsData), loadFromCsv);
	};

	const initAll = () => {
		document.querySelectorAll(SELECTOR).forEach(initRoot);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', () => {
		setTimeout(initAll, 50);
	});

	window.addEventListener('pageshow', (event) => {
		if (!event.persisted) return;
		document.querySelectorAll(SELECTOR).forEach((root) => {
			if (!root._fanHubAll || !root._fanHubAll.length) return;
			const sampleSize = parseInt(root.dataset.fanHubSample, 10) || 100;
			root._fanHubIdle = shuffle(root._fanHubAll, sampleSize);
			fillCrawl(root, root._fanHubIdle);
			applyQuery(root);
		});
	});
})();
